import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../../_models/user-name-display-result-dto';
import { WFEWorkflowRawDto } from '../../../shared-workflow-module/_models/wfe-workflow-raw-dto';
import { WFEConflictDataResultDto } from './wfe-conflict-data-result-dto';

export class WFESupervisorStepEditorResultDto {
    @Type(() => WFEWorkflowRawDto)
    workflow: WFEWorkflowRawDto;

    @Type(() => WFEConflictDataResultDto)
    conflictedFields: Array<WFEConflictDataResultDto>;

    @Type(() => UserNameDisplayResultDto)
    scannedBy: UserNameDisplayResultDto;

    @Type(() => UserNameDisplayResultDto)
    verifiedBy: UserNameDisplayResultDto;
}
